﻿
myApp.controller("contactCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.setPage("contact");//navbar action
    $scope.setPageClass("yit-contact");


    $scope.AllStrings = {
        form:{}
    }
    $scope.WaitForStrings(function () {
 
        var xml = this.strings;
        var page = $(xml).find("contact");
       
        $scope.AllStrings.title = $(page).find("title").find($scope.lang).text().trim();

        $scope.h1 = $(page).find("h1").find($scope.lang).html().trim();
      
        $scope.setTitle($scope.AllStrings.title);//set title to the page
        var form = $(page).find("form")
        $scope.AllStrings.form.h3 = $(form).find("h3").find($scope.lang).html().trim();
         
        $scope.AllStrings.form.name = $(form).find("name").find($scope.lang).html().trim();
        $scope.AllStrings.form.email = $(form).find("mail").find($scope.lang).html().trim();
        $scope.AllStrings.form.phone = $(form).find("phone").find($scope.lang).html().trim();
        $scope.AllStrings.form.company = $(form).find("company").find($scope.lang).html().trim();
        $scope.AllStrings.form.text = $(form).find("text").find($scope.lang).html().trim();
        $scope.AllStrings.form.btn = $(form).find("btn").find($scope.lang).html().trim();
        $scope.AllStrings.form.privacyText = $(form).find("privacyText").find($scope.lang).html().trim();
        $scope.AllStrings.form.privacyLink = $(form).find("privacyLink").find($scope.lang).html().trim();
        $scope.AllStrings.form.privacyErr = $(form).find("privacyErr").find($scope.lang).html().trim();
        require("../second-form");
        
        $(".view-details-toggle").on("click", function () {
            var open = "Show Details";
            var close = "Less Details";
            if (checkLang()) {
                open = "הצג פרטים";
                close = "סגור פרטים";
            }
            var job = $(this).next().next();
            var jobHeight = job.height();
            if (jobHeight > 10) {
                $(this).html(open);
                job.addClass("lined");

            } else {
                job.removeClass("lined");
                $(this).html(close);
            }
        });
    }.bind($scope));
}]);
 


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/contact.js
// module id = 20
// module chunks = 0